<template>
    <div class="waybill">
        <div v-show="accountType != 0">
        <div style="background: #fff;padding: 10px 15px;">
            <textarea v-model="search.waybillNo"
                      style="font-size: 14px;width: calc(100% - 24px);display: inline-block;vertical-align: top;border:none;height:120px;"
                      placeholder="请输入单号"></textarea>
            <p style="color: #ff0b0b;font-size: 12px;">提示：可多票进行分行查询，可根据运单号、原单号、转单号进行查询</p>
        </div>
        <mt-cell title="寄件日期" class="price-cell">
            <mt-field placeholder="选择起使日期" readonly v-model="search.beginTime" @click.native="openPicker"></mt-field>
            至
            <mt-field placeholder="选择终止日期" readonly v-model="search.endTime" @click.native="openPicker2"></mt-field>
            <img src="../../assets/date.png" alt="" class="input-icon" style="padding-right: 10px;">
        </mt-cell>
        <div class="padded mt-gap2">
            <mt-button type="primary" style="width: 100%;" @click.native="searchData()">查询</mt-button>
        </div>


        <mt-datetime-picker
                ref="picker"
                v-model="datePicker"
                type="date"
                @confirm="handleConfirm1">
        </mt-datetime-picker>
        <mt-datetime-picker
                ref="picker2"
                v-model="datePicker2"
                type="date"
                @confirm="handleConfirm2">
        </mt-datetime-picker>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'WaybillQuery',
        data() {
            return {
                accountType: '',
                search: {
                    beginTime: '',
                    endTime: '',
                    waybillNo:'',
                },
                datePicker: '',
                datePicker2: ''
            }
        },
        created() {
            let companyNo = this.$util.get('companyNo');
            this.accountType = this.$util.get(companyNo+'_userInfo').accountType;
            if (this.accountType == 0) {
                this.$toast("此功能只针对客户账号开放");
            } else {
                var date = new Date();
                var date2 = new Date(date.getTime() - 7*24*60*60*1000);
                this.datePicker = date2;
                this.datePicker2 = date;
                this.search.beginTime = this.dateFormat(date2);
                this.search.endTime = this.dateFormat(date);
            }
        },
        methods: {
            openPicker() {
                this.$refs.picker.open();
            },
            openPicker2() {
                this.$refs.picker2.open();
            },
            handleConfirm1() {
                var date = this.datePicker;
                this.search.beginTime = this.dateFormat(date);
            },
            handleConfirm2() {
                var date = this.datePicker2;
                this.search.endTime = this.dateFormat(date);
            },
            dateFormat(date) {
                var year = date.getFullYear();
                var month = date.getMonth()+1;
                if (month < 10) {
                    month = '0'+month;
                }
                var day = date.getDate();
                if (day < 10) {
                    day = '0'+day;
                }
                return year+'-'+month+'-'+day;
            },
            searchData() {
                let start = new Date(this.search.beginTime).getTime();
                let end = new Date(this.search.endTime).getTime();
                if (end < start) {
                    this.$toast("截止时间需大于起始时间");
                    return;
                }
                if (end - start > 30 * 24 * 60 * 60 * 1000) {
                    this.$toast("查询时间跨度最多能超过30天");
                    return;
                }
                let waybillNo = this.search.waybillNo?this.search.waybillNo.replace(/\s/g,''):'';
                if (waybillNo || (this.search.beginTime && this.search.endTime)) {
                    this.$router.push({name: 'Waybill', query: {beginTime: this.search.beginTime,endTime: this.search.endTime, waybillNo: this.search.waybillNo}});
                } else {
                    this.$toast("请输入查询条件");
                }
            }
        }
    }
</script>
<style scoped>
    .waybill .price-cell >>> .mint-field-core {
        text-align: center;
    }
    .waybill .price-cell {
        background-image: none;
        margin-top: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/page/waybill/waybill-query.vue